import { Component, Inject, AfterViewInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Chart } from 'angular-highcharts';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-expand-chart',
  template: `
    <mat-dialog-content class="modal-content">
      <!-- Close icon top-right -->
      <span class="close-button" (click)="dialogRef.close()">✖</span>

      <div class="chart-container">
        <div [chart]="data.chart"></div>
      </div>
    </mat-dialog-content>
  `,
  styles: [`
    ::ng-deep .mat-dialog-container {
      padding: 0 !important;
      border-radius: 15px !important;
      overflow: hidden !important;
      background: transparent !important;
      box-shadow: 0 4px 15px rgba(0,0,0,0.25);
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;
      background: white; /* chart ke liye background */
      border-radius: 10px;
      padding: 20px;
      text-align: center;
      border: 8px solid transparent;
      border-image: linear-gradient(to right, #4facfe 20%, #00f2fe 80%);
      border-image-slice: 1;
    }

    .chart-container {
      flex-grow: 1;
      min-height: 200px;
      height: 100%;
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 22px;
      cursor: pointer;
      color: #333;
      z-index: 10;
      transition: color 0.2s;
    }

    .close-button:hover {
      color: red;
    }
  `]
})
export class ExpandChartComponent implements AfterViewInit, OnDestroy {
  private chartSubscription!: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { vesselName: string; chart: Chart },
    public dialogRef: MatDialogRef<ExpandChartComponent>
  ) {}

  ngAfterViewInit() {
    this.chartSubscription = this.data.chart.ref$.subscribe((chartInstance) => {
      if (chartInstance) chartInstance.reflow();
    });
    
    window.addEventListener('highchartsReflowRequest', this.handleReflow);
  }
  
  handleReflow = () => {
    const chartInstance = (this.data.chart as any)?.ref;
    if (chartInstance) chartInstance.reflow();
  }

  ngOnDestroy() {
    if (this.chartSubscription) this.chartSubscription.unsubscribe();
    window.removeEventListener('highchartsReflowRequest', this.handleReflow);
  }
}
